module.exports = __webpack_public_path__ + "static/7b-7e641a5b72e296ee7da1c268ce913f8a.png";